import { Box, Heading, Button, Flex, Text, HStack, useColorModeValue } from '@chakra-ui/react'
import { Link as NavLink, useNavigate } from 'react-router-dom'
import { FaPlus } from 'react-icons/fa'
import { useQuery, gql } from '@apollo/client'

import { Page, AddApplicationModal, Status, Table } from '../components'

const DASHBOARD_QUERY = gql`
  query Dashboard {
    apps {
      items {
        id
        name
        displayName
        status
        deployments {
          id
          createdAt
        }
      }
      total
    }
  }
`

const Dashboard = () => {
  const navigate = useNavigate()
  const borderColor = useColorModeValue('gray.300', 'whiteAlpha.300')

  const { data, error, loading, refetch } = useQuery(DASHBOARD_QUERY, {
    pollInterval: 5000,
  })

  const applications = data?.apps?.items ?? []

  return (
    <>
      <Page>
        <Flex alignItems="center">
          <Heading>My Applications</Heading>
          <Button
            size="sm"
            ml="auto"
            bg="cyan.400"
            color="white"
            _hover={{ bg: 'cyan.600' }}
            onClick={() => navigate('/app/new')}
          >
            <HStack alignItems="center">
              <FaPlus />
              <Text>New</Text>
            </HStack>
          </Button>
        </Flex>
        <Box
          mt={8}
          pt={2}
          pb={1}
          rounded="lg"
          border="1px"
          borderColor={borderColor}
        >
          {error ? (
            <Text px={6} py={4} size="md">
              There was an error during fetching your applications. 🤕
            </Text>
          ) : !applications.length ? 
          <Text px={6} py={4} size="md">
              There are no applications added. Add a new one!
            </Text>
           : loading ? (
            <Text px={6} py={4} size="md">
              Loading applications...
            </Text>
          ) : (
            <Table
              columns={[
                {
                  Header: 'Name',
                  accessor: 'displayName',
                  Cell: ({ row: { original: row } }) => {
                    return (
                      // @ts-ignore
                      <NavLink to={`/app/${row.name}/deployments`}>
                        {/* @ts-ignore */}
                        <b>{row.displayName}</b>
                      </NavLink>
                    )
                  },
                },
                {
                  Header: 'Status',
                  accessor: 'status',
                  Cell: ({ value }) => <Status status={value} />,
                },
                {
                  Header: 'Last deployed',
                  accessor: (row) => {
                    // @ts-ignore
                    const [deployment] = row.deployments

                    return !deployment
                      ? 'Not deployed'
                      : new Intl.DateTimeFormat('en-US', {
                          timeStyle: 'short',
                          dateStyle: 'medium',
                          // @ts-ignore
                        }).format(deployment.createdAt)
                  },
                  // @ts-ignore
                  isNumeric: true,
                },
              ]}
              data={applications}
            />
          )}
        </Box>
      </Page>
      <AddApplicationModal refetchAppList={refetch} />
    </>
  )
}

export default Dashboard
